export function getOffset(
	element: Element
): { top: () => number; left: () => number } {
	const clientRect = element.getBoundingClientRect();

	return {
		top: () => {
			const ownerDocument = element.ownerDocument;
			const documentTop = window.pageYOffset || ownerDocument.body.scrollTop;
			return (
				clientRect.top + documentTop - ownerDocument.documentElement.clientTop
			);
		},
		left: () => {
			const ownerDocument = element.ownerDocument;
			const documentLeft = window.pageXOffset || ownerDocument.body.scrollLeft;
			return (
				clientRect.left +
				documentLeft -
				ownerDocument.documentElement.clientLeft
			);
		},
	};
}
